import React  from 'react';
import stl from './PaymentAndAgreementOptions.module.css';
import Checkbox from "../../atoms/Checkbox";
import Btn from "../../atoms/Btn";
import SvgStripeIcon from "../../assets/icons/SvgStripeIcon";

const PaymentAndAgreementOptions = ({onPay, commissionChecked, setCommissionChecked, termsChecked, setTermsChecked, fee, amount}) => {

  return(
        <div className={stl.container}>
            <div className={stl.actionBox}>
                <Checkbox checked={commissionChecked} onChange={() => setCommissionChecked(!commissionChecked)}
                          id="commission-checkbox"
                          label={`I accept the $${fee} processing fee`}/>
                <Checkbox checked={termsChecked} onChange={() => setTermsChecked(!termsChecked)}
                          id="terms-checkbox"
                          label={
                              <span>
                            I agree to the{' '}
                            <a href="https://stripe.com/legal/consumer" target="_blank" rel="noopener noreferrer" className={stl.link}>
                                 Terms
                            </a>
                                  {' '} &{' '}
                            <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" className={stl.link}>
                                Privacy
                            </a>
                        </span>
                          }/>
            </div>
            <div className={stl.actionBox}>
                <Btn onClick={onPay} disabled={!termsChecked}
                     label={`Pay ${(Number(commissionChecked ? fee : 0) + Number(amount)).toFixed(2)}`}
                     className={stl.paymentBtn} icon={<SvgStripeIcon/>}/>
            </div>
        </div>
    );
}

export default PaymentAndAgreementOptions;
